import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const postGroupCreationStateSlice = createSlice({
	name: 'postGroupCreationState',
	initialState,
	reducers: {
		setPostGroupCreationState: (state, action: PayloadAction<boolean>) => {
			return action.payload;
		}
	}
});

export const { setPostGroupCreationState } = postGroupCreationStateSlice.actions;

export default postGroupCreationStateSlice.reducer;
